import React,{Component} from 'react';
import './SearchPg.css';

import { FiSearch,FiPaperclip } from 'react-icons/fi';

import ScrollContainer from "react-indiana-drag-scroll";

import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
  } from "react-router-dom";
const list = [

    { name: "Khaadi", value: "1" },
    { name: "Limelight", value: "2" },
    { name: "Sapphire", value: "3" },
    { name: "Gulahmed", value: "4" },
    { name: "J. | JunaidJamshed", value: "5" },
    { name: "Ittehad Textiles", value: "6" },
    { name: "Waniya", value: "7" },
    { name: "Shoes", value: "10" },
    { name: "Jewellery", value: "11" },
    { name: "Dress", value: "12" },
    { name: "Bed Sheet", value: "13" },
    { name: "2PC", value: "14" },
    { name: "3PC", value: "15" },
    { name: "Stitched", value: "16" },
    { name: "Unstitched", value: "17" }

];

class SearchHome extends React.Component{

    constructor(props){
        super(props);
        this.state={
            clicked:[],
            activateCat: [],
            ShowSearchPage:false
        }
    }
   
    ToggleCat = (e, ele) => {

        if (!this.state.activateCat.includes(ele)) {
            this.setState({
                activateCat: [...this.state.activateCat, ele]
            });
        }
        if (this.state.activateCat.includes(ele)) {
            let remove = this.state.activateCat.indexOf(ele);
            this.setState({
                activateCat: this.state.activateCat.filter((_, i) => i !== remove)
            });

        }
        console.log("categories=" + this.state.activateCat);
    }





    render(){
        
var bor;
        return(
      <div className="headCon">
               <div className="SearchBaar">
                   <div className="InnerSearch">
                   <FiSearch className="inline_items Logo Search" />

                      <NavLink to="/searchpage" className="TextBox inline_items" >Search</NavLink> 
                      <input type="file" className="Uploader" name="img" accept="image/*" ref={(ref) => this.myInput = ref} style={{ display: 'none' }}
                      onChange={(e) => {
                          
                        console.log( document.querySelector('input').files[0]);
                           } }
                      
                      />
                      <FiPaperclip className="inline_items Logo attatch" onClick={(e) =>this.myInput.click()
                 } />
                   </div>
               </div>
               
            <div className="Filteration">
            <div className = "CategoricalBox" >
                <ScrollContainer className = "NavOuterBox" >
                <div className = "NavOuterBox_Contents " >

                {
                    list.map(el => {
                            const { name } = el;

                            if (this.state.activateCat.includes(name))
                                bor = "borderBlue";
                            else
                                bor = "border";
                            return ( < div className = { `NavOuterBox_Link ${bor}` }
                                key = { name }
                                onClick = {
                                    (e) => this.ToggleCat(e, name) } >

                                <NavLink to={`/${name}`} className = "NavInnerBox"
                                key = { el } > { name } 
                                </NavLink> </div>);
                            })
                    } </div> </ScrollContainer> 
                    </div> 
                </div>  
            
            </div>
        );
    }
}
export default SearchHome;